import React from 'react';
import { array, func, node, string } from 'prop-types';
import useDetectBounding from './useDetectBounding';

// eslint-disable-next-line no-unused-vars
function InfiniteVerticalScrollContainer({
  className,
  children,
  marginList,
  onScrollTopBounding,
  onScrollBottomBounding,
}) {
  const topBoundingRef = useDetectBounding(marginList, onScrollTopBounding);
  const bottomBoundingRef = useDetectBounding(
    marginList,
    onScrollBottomBounding,
  );

  return (
    <div className={className}>
      <div ref={topBoundingRef} />
      {children}
      <div ref={bottomBoundingRef} />
    </div>
  );
}

InfiniteVerticalScrollContainer.defaultProps = {
  marginList: [0, 0],
  className: '',
  onScrollTopBounding: () => {},
  onScrollBottomBounding: () => {},
};

InfiniteVerticalScrollContainer.propTypes = {
  children: node.isRequired,
  onScrollTopBounding: func,
  onScrollBottomBounding: func,
  marginList: array,
  className: string,
};

export default InfiniteVerticalScrollContainer;
